import { toZonedTime, fromZonedTime } from "date-fns-tz";

const BERLIN_TZ = "Europe/Berlin";

/**
 * Parse a naive datetime string from Storyblok (e.g. "2026-04-14 19:00")
 * as Berlin time, returning a proper UTC-based Date object.
 *
 * This ensures "19:00" always means 19:00 Berlin time regardless of
 * the user's local timezone.
 */
export function parseBerlinDate(dateStr: string): Date {
  if (!dateStr) return new Date(0);
  const normalized = dateStr.replace(" ", "T");
  // fromZonedTime: treat the naive date as if it's in Berlin timezone
  return fromZonedTime(normalized, BERLIN_TZ);
}

/**
 * Get the start of today in Berlin timezone as a UTC Date.
 * Used for cutoff comparisons (filtering past events).
 */
export function startOfTodayBerlin(): Date {
  // Get current time in Berlin
  const nowInBerlin = toZonedTime(new Date(), BERLIN_TZ);
  // Set to midnight Berlin time
  nowInBerlin.setHours(0, 0, 0, 0);
  // Convert back to UTC
  return fromZonedTime(nowInBerlin, BERLIN_TZ);
}

export { BERLIN_TZ };
